export const SHOW_ERROR = "ERROR/SHOW";
export const CLEAR_ERROR = "ERROR/CLEAR";

/**
 * Simple action to store an error in redux state
 * errType: string (one of ERROR_TYPES)
 * message: optional string
 */
export const showUnpaidError = (unpaidError) => ({
  type: SHOW_ERROR,
  payload: { unpaidError },
});

export const clearUnpaidError = () => ({ type: CLEAR_ERROR });

/**
 * Thunk that dispatches the error into the store and then navigates
 * to the centralized error page with query params.
 *
 * Usage: dispatch(showErrorAndRedirect(errType, message));
 */
export const showUnpaidErrorAndRedirect = (errType, message = "") => (dispatch) => {
  dispatch(showUnpaidError(errType, message));

  try {
    const errorUrl = `${window.location.origin}/unpaid`;
    // replace so back doesn't return to protected page
    window.location.replace(errorUrl);
  } catch (navErr) {
    // swallow navigation errors
  }
};